'use client';
import { useCmsHashState } from '../../hooks/useHashState';
import { VerticalType } from '../../types/cmsTypes';

export type CarInsuranceCentralModalState = {
  carInsuranceCentralModalOpen?: 'true';
};

export const useCarInsuranceCentralModal = (
  vertical: VerticalType | undefined,
) => {
  const [params, setHashParams] =
    useCmsHashState<CarInsuranceCentralModalState>({
      carInsuranceCentralModalOpen: 'string',
    });

  const isCarInsurance = vertical === 'CAR_INSURANCE';

  const isOpen =
    isCarInsurance && params.carInsuranceCentralModalOpen === 'true';
  const openModal = () =>
    isCarInsurance && setHashParams({ carInsuranceCentralModalOpen: 'true' });
  const closeModal = () =>
    isCarInsurance &&
    setHashParams({ carInsuranceCentralModalOpen: undefined });
  const toggleModal = () => {
    if (!isCarInsurance) return;
    if (isOpen) closeModal();
    else openModal();
  };

  return { isOpen, openModal, closeModal, toggleModal };
};
